import Db from '@/api/awsDb';

export default {
  namespaced: true,
  state: {
    industry: [],
    publisher: [],
    type: [],
    environment: [],
    chiefList: [],
    category: [],
    product: [],
    customList: [],
    permissionList: [],
    policyList: [],
    filterList: [],
    filterSubject: '',
    filterParams: {
      industrys: 'All', publishers: 'All', types: 'All', runtimeEnvironment: 'All',
    },
  },
  getters: {
    isLoadCategory: (state) => (state.category.length),
    isLoadProduct: (state) => (state.product.length),
    productList: (state, getters, rootState, rootGetters) => (state.product.filter((x) => x.locale === rootGetters['locale/locale'])),
    industryList: (state, getters, rootState, rootGetters) => (state.industry.filter((x) => x.locale === rootGetters['locale/locale'])),
    publisherList: (state, getters, rootState, rootGetters) => (state.publisher.filter((x) => x.locale === rootGetters['locale/locale'])),
    typeList: (state, getters, rootState, rootGetters) => (state.type.filter((x) => x.locale === rootGetters['locale/locale'])),
    environmentList: (state, getters, rootState, rootGetters) => (state.environment.filter((x) => x.locale === rootGetters['locale/locale'])),
    categoryList: (state, getters, rootState, rootGetters) => (state.category.filter((x) => x.locale === rootGetters['locale/locale'])),
    getIndustryById: (state) => (id) => state.industry.find((x) => x.id === id),
    getPublisherById: (state) => (id) => state.publisher.find((x) => x.id === id),
    getTypeById: (state) => (id) => state.type.find((x) => x.id === id),
    getEnvironmentById: (state) => (id) => state.environment.find((x) => x.id === id),
    getChiefById: (state) => (id) => state.chiefList.find((x) => x.id === id),
    permissionId: (state) => (name) => {
      const temp = state.permissionList.find((x) => x.name === name);
      return temp ? temp.id : '';
    },
    permissionName: (state) => (id) => {
      const temp = state.permissionList.find((x) => x.id === id);
      return temp ? temp.name : '';
    },
    policyByUserType: (state) => (type) => state.policyList.find((x) => x.userType === type),
    generalIndustryId: (state) => (locale) => {
      const name = locale === 'en-us' ? 'General' : '通用產業';
      const temp = state.category.find((x) => x.category === 'industrys' && x.name === name);
      return temp.id;
    },
  },
  mutations: {
    setFilterList(state, list) {
      state.filterList = list;
    },
    setFilterSubject(state, subject) {
      state.filterSubject = subject;
    },
    setFilterParams(state, params) {
      state.filterParams = params;
    },
    clearFilterParams(state) {
      state.filterParams = {
        industrys: 'All', publishers: 'All', types: 'All', runtimeEnvironment: 'All',
      };
    },
  },
  actions: {
    loadCategory({ state }) {
      return new Promise((resolve) => {
        Db.scan('category').then((res) => { // cherry rootGetters['locale/locale']
          state.category = res;
          state.industry = res.filter((x) => x.category === 'industrys');
          state.publisher = res.filter((x) => x.category === 'publishers');
          state.type = res.filter((x) => x.category === 'types');
          state.environment = res.filter((x) => x.category === 'runtimeEnvironment');
          state.chiefList = res.filter((x) => x.category === 'chiefs');
          resolve(res);
        });
      });
    },
    loadProduct({ state, getters }) {
      return new Promise((resolve) => { // cherry rootGetters['locale/locale']
        Db.scan('product', {}, [
          'id',
          'name',
          'publishers',
          'icon',
          'price',
          'rating',
          'updateTime',
          'industrys',
          'types',
          'runtimeEnvironment',
          'discount',
          'discountPeriod',
          'urls0',
          'urls1',
          'urls2',
          'description',
          'locale',
          'chargeTypeId',
        ]).then((res) => {
          state.product = res.map((x) => ({
            id: x.id,
            name: x.name,
            publishers: x.publishers,
            publisherName: getters.getPublisherById(x.publishers).name,
            icon: x.icon,
            price: x.price,
            rating: x.rating || 0,
            updateTime: x.updateTime || 0,
            industrys: x.industrys,
            industryName: getters.getIndustryById(x.industrys).name,
            types: x.types,
            typeName: getters.getTypeById(x.types).name,
            runtimeEnvironment: x.runtimeEnvironment,
            runtimeEnvironmentName: getters.getEnvironmentById(x.runtimeEnvironment).name,
            discount: x.discount,
            discountPeriod: x.discountPeriod,
            urls0: x.urls0,
            urls1: x.urls1,
            urls2: x.urls2,
            description: x.description,
            locale: x.locale,
            chargeTypeId: x.chargeTypeId,
          }));
          resolve(state.product);
        });
      });
    },
    loadCustom({ state }) {
      return new Promise((resolve) => {
        Db.scan('custom').then((res) => {
          state.customList = res;
          resolve(res);
        });
      });
    },
    loadPermission({ state }) {
      return new Promise((resolve) => {
        Db.scan('permission').then((res) => {
          state.permissionList = res.filter((x) => x.type === 'permission');
          state.policyList = res.filter((x) => x.type === 'policy');
          resolve(res);
        });
      });
    },
  },
};
